import * as React from 'react';
import classNames from 'classnames';
import { DifficultyOptions, Recipe } from '@src/firebase/types';

interface ViewStatsProps {
  className?: string;
  recipe: Recipe;
}

/**
 * @name ViewStats
 * @description tbd...
 */
const ViewStats: React.FC<ViewStatsProps> = (props) => {
  const { className, recipe } = props;

  // Setup
  const timeToCook = recipe.prepMinutes + recipe.cookMinutes;
  const difficulty = DifficultyOptions[recipe.difficulty];

  return (
    <section
      className={classNames(
        className,
        '-mt-16 max-w-7xl mx-auto relative z-10 pb-8 px-4 sm:px-6 lg:px-8',
      )}
      aria-labelledby="contact-heading"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <dl className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3">
            <div className="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r">
              <dt className="order-2 mt-2 text-md leading-6 font-medium text-gray-500">
                Minutes
              </dt>
              <dd className="order-1 text-4xl font-extrabold text-indigo-600">
                {timeToCook}
              </dd>
            </div>
            <div className="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r">
              <dt className="order-2 mt-2 text-md leading-6 font-medium text-gray-500">
                Difficulty
              </dt>
              <dd className="order-1 text-4xl font-extrabold text-indigo-600">
                {difficulty}
              </dd>
            </div>
            <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
              <dt className="order-2 mt-2 text-md leading-6 font-medium text-gray-500">
                Servings
              </dt>
              <dd className="order-1 text-4xl font-extrabold text-indigo-600">
                {recipe.servings}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
};

export { ViewStats };
export type { ViewStatsProps };
